import { ProfileForRequest, AsOf, AsOfType, AsOfData, AsOfRelativeUnit } from '@/store/types';
import store from '@/store';
import moment from 'moment';

export default {
  round(value: number, decimals: number = 2) {
    // @ts-ignore - Math.round should accept 'e'
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
  },
  convertAsOfToDate(asOf: AsOf): Date {
    switch (asOf.type) {
      case AsOfType.Static:
        return new Date(asOf.data as string);

      case AsOfType.Relative:
        const { count, unit } = asOf.data as AsOfData;
        return moment().subtract(moment.duration(count, unit)).toDate();

      default:
        return new Date();
    }
  },
  getAsOfRelative(asOf: AsOf): AsOfData {
    switch (asOf.type) {
      case AsOfType.Static:

        const end = moment().startOf('day');
        const start = moment(asOf.data as string, 'YYYY-MM-DD').startOf('day');
        const days = end.diff(start, 'days');
        const diff = moment.duration(days, 'days').asDays() as number;
        return { count: diff, unit: AsOfRelativeUnit.Day };

      case AsOfType.Relative:
        return { ...asOf.data as AsOfData };
    }
  },
  isDateOutsideRange(time: number, minTime: number, maxTime: number): boolean {
    if (minTime > time || maxTime < time) {
      return true;
    }

    return false;
  },
  exportCSVFile(csv: string, fileTitle: string) {

    const exportedFilename = fileTitle + '.csv' || 'export.csv';
    const blob = new Blob([csv]);

    if ((navigator as any).msSaveBlob) { // IE 10+
      (navigator as any).msSaveBlob(blob, exportedFilename);
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      if (link.download !== undefined) {
        link.href = url;
        link.setAttribute('download', exportedFilename);
        link.click();
        document.body.removeChild(link);
      }
    }
  },
  /**
   * Returns a boolean indicating if the arrays are different (true) or the same (false)
   * @param arr1 
   * @param arr2 
   */
  compareArrays(arr1: any[], arr2: any[]): boolean {
    let diff = false;

    if (arr1.length !== arr2.length) {
      diff = true;
    } else {
      const length = arr1.length;
      for (let i = 0; i < length; i++) {
        if (arr1.indexOf(arr2[i]) === -1) {
          diff = true;
        }
        if (arr2.indexOf(arr1[i]) === -1) {
          diff = true;
        }
      }
    }

    return diff;
  },
  convertBucketToAttributeParams(profile: any, options: any): any {
    profile.attributes.forEach( (attrId: string) => {
      const fullAttr = options.attributes.find((attr: any) => attr.id === attrId);
      // Check if this attribute supports bucketing
      if (fullAttr && fullAttr.fixed_order) { // TODO: change to use new flag
        profile.attribute_params = profile.attribute_params || {};
        profile.attribute_params[attrId] = {
          buckets: store.getters.getBucketingForAttribute(attrId).value
        };
      }
    });

    return profile;
  }
};
